var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BoardView',{attrs:{"title":_vm.$t('title')}},[_c('FormReviewImport',{attrs:{"reviewImport":_vm.reviewImport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }